import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import addWishlistItemMutation from '~/graphql/wishlist/addWishlistItem.gql';
import deleteWishlistItemMutation from '~/graphql/wishlist/deleteWishlistItem.gql';
import wishlistQuery from '~/graphql/wishlist/wishlist.gql';
import { isValidToken } from '~/helpers/connection-helper';
function fetchDetailedWishlist(_x, _x2) {
  return _fetchDetailedWishlist.apply(this, arguments);
}
function _fetchDetailedWishlist() {
  _fetchDetailedWishlist = _asyncToGenerator(function* (_ref, _ref2) {
    var {
      app,
      getters
    } = _ref;
    var {
      offset,
      limit,
      isPrivateSales
    } = _ref2;
    if (isValidToken()) {
      var locale = getters['i18n/locale'].iso;
      var {
        data
      } = yield app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: wishlistQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          locale,
          detailed: true,
          offset,
          limit,
          isPrivateSales
        }
      });
      return data && data.wishlist;
    }
    return null;
  });
  return _fetchDetailedWishlist.apply(this, arguments);
}
function fetchWishlist(_x3) {
  return _fetchWishlist.apply(this, arguments);
}
function _fetchWishlist() {
  _fetchWishlist = _asyncToGenerator(function* (context) {
    var detailed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (isValidToken()) {
      var locale = context.state.i18n.currentLocale;
      var response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: wishlistQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          locale: locale.iso,
          detailed
        }
      });
      return response.data;
    }
    return null;
  });
  return _fetchWishlist.apply(this, arguments);
}
function addWishlistItem(_x4, _x5) {
  return _addWishlistItem.apply(this, arguments);
}
function _addWishlistItem() {
  _addWishlistItem = _asyncToGenerator(function* (context, reference) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: addWishlistItemMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          reference
        }
      });
      return response.data;
    }
    return null;
  });
  return _addWishlistItem.apply(this, arguments);
}
function deleteWishlistItem(_x6, _x7) {
  return _deleteWishlistItem.apply(this, arguments);
}
function _deleteWishlistItem() {
  _deleteWishlistItem = _asyncToGenerator(function* (context, reference) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: deleteWishlistItemMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          reference
        }
      });
      return response.data;
    }
    return null;
  });
  return _deleteWishlistItem.apply(this, arguments);
}
export { fetchDetailedWishlist, fetchWishlist, addWishlistItem, deleteWishlistItem };